import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTextBalloon({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M.094.13h1.999v3.248h-2z" />
				<path id="c" d="M.063.026H5.12V8.01H.063z" />
				<path id="e" d="M0 .026h5.058V8.01H0z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M9.853 13.71a.359.359 0 1 1-.718-.002.359.359 0 0 1 .718.002"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M9.494 13.668a.04.04 0 0 0-.041.042c0 .044.082.044.082 0a.04.04 0 0 0-.041-.042m0 .717a.676.676 0 1 1 0-1.353.676.676 0 0 1 0 1.353m2.988-.675a.359.359 0 1 1-.718-.003.359.359 0 0 1 .718.003"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M12.123 13.668a.04.04 0 0 0-.04.042c0 .045.082.043.082 0a.04.04 0 0 0-.042-.042m0 .717a.676.676 0 1 1 .001-1.352.676.676 0 0 1 0 1.352m2.988-.675a.359.359 0 1 1-.718-.002.359.359 0 0 1 .718.002"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M14.752 13.668a.04.04 0 0 0-.04.042c0 .045.082.044.082 0a.04.04 0 0 0-.042-.042m0 .717a.676.676 0 1 1 .001-1.353.676.676 0 0 1 0 1.353"
				/>
				<path
					fill="#FEFEFE"
					fillRule="nonzero"
					d="M16.69 19.25c-3.283-.004-4.15-1.917-4.15-2.928a.317.317 0 0 1 .635-.002c.001.099.07 2.292 3.515 2.296a.318.318 0 0 1 0 .634"
				/>
				<path
					fill="#FEFEFE"
					fillRule="nonzero"
					d="M12.857 16.639H7.61a1.153 1.153 0 0 1-1.153-1.15v-3.603a.317.317 0 0 1 .636 0v3.603c0 .284.232.515.517.515h5.248a.317.317 0 1 1 0 .635m3.741-.002h-.896a.317.317 0 1 1 0-.634h.896a.517.517 0 0 0 .517-.517v-3.598a.317.317 0 0 1 .636 0v3.598c0 .635-.517 1.15-1.153 1.15"
				/>
				<path
					fill="#FEFEFE"
					fillRule="nonzero"
					d="M6.774 13.186a.317.317 0 0 1-.318-.318V9.762c0-.634.517-1.15 1.152-1.15h8.42a.317.317 0 1 1 0 .634h-8.42a.517.517 0 0 0-.516.516v3.106a.317.317 0 0 1-.318.318"
				/>
				<path
					fill="#FEFEFE"
					fillRule="nonzero"
					d="M17.434 13.181a.317.317 0 0 1-.318-.317V9.762a.517.517 0 0 0-.517-.516h-.896a.317.317 0 1 1 0-.634h.896c.635 0 1.153.516 1.153 1.15v3.102a.317.317 0 0 1-.318.317"
				/>
				<g transform="translate(14.915 15.872)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#FEFEFE"
						fillRule="nonzero"
						d="M1.775 3.379a.3.3 0 0 1-.174-.052C1.456 3.232.186 2.373.098 1.339.063.924.227.536.572.216a.318.318 0 0 1 .433.464c-.203.188-.292.386-.274.606.053.62.897 1.3 1.218 1.51a.317.317 0 0 1-.174.583"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(16.092 4.12)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#FEFEFE"
						fillRule="nonzero"
						d="M1.342 8.009a.318.318 0 0 1-.04-.632c2.077-.27 2.994-1.854 3.16-3.246C4.702 2.094 3.027.958 3.01.947c-.279-.185-.495-.26-.618-.28.017.03.04.068.07.105.01.013 1.101 1.405.721 2.663-.487 1.61-2.42 1.69-2.803 1.69a.317.317 0 1 1 0-.634c.304 0 1.838-.06 2.195-1.24.276-.914-.598-2.069-.607-2.08-.205-.254-.35-.627-.144-.915.258-.357.847-.295 1.537.162.699.464 1.96 1.851 1.73 3.787-.193 1.63-1.269 3.483-3.708 3.801l-.042.003"
						mask="url(#d)"
					/>
				</g>
				<g transform="translate(3 4.12)">
					<mask id="f" fill="#fff">
						<use xlinkHref="#e" />
					</mask>
					<path
						fill="#FEFEFE"
						fillRule="nonzero"
						d="m3.779 8.009-.042-.003C1.297 7.688.222 5.834.028 4.206-.202 2.269 1.06.882 1.758.418c.69-.457 1.28-.52 1.537-.162.207.288.062.661-.143.914-.01.012-.883 1.167-.607 2.082.357 1.18 1.891 1.24 2.195 1.24a.317.317 0 1 1 0 .634c-.383 0-2.317-.082-2.804-1.69-.38-1.259.711-2.651.722-2.665a1 1 0 0 0 .07-.105c-.123.02-.34.096-.618.28C2.093.959.418 2.095.66 4.132c.164 1.391 1.08 2.974 3.16 3.245a.317.317 0 0 1-.041.632"
						mask="url(#f)"
					/>
				</g>
			</g>
		</svg>
	);
}
